/*
 * @Author: BaiZhiming
 * @Date: 2015-11-12
 * @LastEditTime: 2021-04-19 10:37:15
 * @LastEditors: lzy
 * @FilePath: \xjmediacloud\app\editingCenter\service\timingSign\timingSign.js
 * @Description: 定时签发模块
 */
'use strict';
angular.module('timingSignModule', ['mgcrea.ngStrap.timepicker', 'mgcrea.ngStrap.datepicker']).controller('timingSignCtrl', [
    '$scope',
    '$filter',
    '$modalInstance',
    'params',
    'SetTime',
    'globleParamsSet',
    function($scope, $filter, $modalInstance, params, SetTime, globleParamsSet) {
        initStatus();
        $scope.sendTimeSigned = function() {
            var timeSigned = $filter('date')($scope.status.sharedDate, 'yyyy-MM-dd').toString() + ' ' + $filter('date')($scope.status.sharedTime, 'HH:mm').toString();
            $modalInstance.close(timeSigned);
        };
        // 暂留
        $scope.deleteTimeSigned = function(index) {
            params.selectedArray.splice($scope.data.items.indexOf(index), 1);
        };
        // 取消关闭开始
        $scope.cancelTimeSigned = function() {
            $modalInstance.close(false);
        };

        /**
         * [initStatus description]
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.windowTitle = '定时签发';
            $scope.confirmName = '发送';
            // bug
            $scope.status = {
                sharedDate: params.selectedArray.length === 1 && params.selectedArray[0].TIMINGPUBLISHTIME ? new Date(params.selectedArray[0].TIMINGPUBLISHTIME) : new Date(), // 单篇修改-显示定时签发时间，批量修改-显示当前系统时间
                sharedTime: params.selectedArray.length === 1 && params.selectedArray[0].TIMINGPUBLISHTIME ? new Date(params.selectedArray[0].TIMINGPUBLISHTIME) : new Date(), // 单篇修改-显示定时签发时间，批量修改-显示当前系统时间
                isNewDraft: params.isNewDraft,
            };
            // 在设置定时签发后,修改定时签发显示定时签发的时间,暂时不需要这个逻辑
            // if (SetTime && SetTime !== '') {
            //     $scope.status.sharedDate = SetTime;
            //     $scope.status.sharedTime = SetTime;
            // }
            // 多个稿件修改定时签发,取当前时间加1分钟
            if (params.selectedArray.length > 1) {
                $scope.status.sharedDate.setMinutes($scope.status.sharedDate.getMinutes() + 1);
            }
            $scope.data = {
                items: params.selectedArray,
                customConfig: {
                    singleDatePicker: true, // 是否是单选框
                    minDate: globleParamsSet.dateFormat(new Date(), '-'),
                    
                },
            };
            // 一键快签的标题和按钮的名称不同
            if (params.isQuickSign) {
                $scope.windowTitle = '一键快签';
                $scope.confirmName = '确定';
            }
        }
    },
]);
